import Vue from 'vue'
import App from './App.vue'
import ElementUi from 'element-ui'
import router from './router/router'
import axios from 'axios'
import store from './store'
import bus from "./core/event-bus";
Vue.prototype.$bus = bus;
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
// 地图标点
import VueKonva from 'vue-konva' // 加这行
Vue.use(VueKonva) // 加这行
// 引入滑动验证码
import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.component('slide-verify', SlideVerify)
// 引入防护逻辑
// import './assets/css/global.css'
// import protectMixin from './utils/protect'; 
// Vue.mixin(protectMixin);

// 禁止浏览器放大
const meta = document.createElement('meta')
meta.name = 'viewport'
meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no'
document.head.appendChild(meta)

Vue.config.productionTip = false
// axios.defaults.baseURL='http://localhost:33024'
// axios.defaults.baseURL='http://www.yangxiao411.chat'
Vue.prototype.$http=axios
Vue.use(ElementUi)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

